import ParcelexApi from '@/services/parcelex';
import globals from '@/globals';

export default {
  async getGuarantorApplication({ guarantorApplicationId }) {
    const qs = new URLSearchParams({
      withTransaction: true,
    }).toString();

    const response = await ParcelexApi.get(`/guarantor/application/${guarantorApplicationId}?${qs}`);
    return response.data;
  },
  signGuarantorApplication({ guarantorApplicationId }) {
    return ParcelexApi.post(`/guarantor/application/${guarantorApplicationId}/sign`);
  },
  getCCBUrl({ checkoutOptionId }) {
    return `${globals().apiUrl}/public/ccb/guarantor/${checkoutOptionId}`;
  },
};
